export const DELETE = 'DELETE';
export const UPDATE = 'UPDATE';
export const WAITING_LIST = 'WAITING_LIST';

export const BACKGROUND = 'background';
export const APPOINTMENT = 'appointment';
export const EVENT_SOURCE_ID = 'event_source_id';
